import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../i18n/components/T.js'

interface Props {
  canAddModel: boolean
  onAddModel: () => void
}
export const ModelsAccordionButton = ({ canAddModel, onAddModel }: Props) => {
  return (
    <div className="flex items-center">
      <div className="flex-1 truncate font-semibold">
        <T defaultMessage="Models" id="Generics.CMS.Models" />
      </div>
      {canAddModel && (
        <div
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            onAddModel()
          }}
        >
          <SvgIcon name="plus" size="lg" />
        </div>
      )}
    </div>
  )
}
